import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import Molecule from "../../MComponent/Molecule";
import "./pms.css";
import Coaching from "./Coaching";
import SelfDevelopment from "./SelfDevelopment";
import TrainingNeeds from "./TrainingNeeds";
import Confidential from "./Confidential";
import Dimension from "./Dimension/Dimension";
import Summary from "./Summary/Summary";
import { useLocation } from "react-router-dom";
import { getActions, getUserId } from "../../Utils/Common/Library";
import { useHistory } from "react-router-dom";
import { loadPlan, reloadPlanBasedOnScores } from "./planLoader";
import store from "../../Redux/Store";

const { Tabs, EwModal } = Molecule;

function getSection(type, planStore, setPlanStore) {
  switch (type) {
    case "SummarySection":
      return {
        Component: Summary,
        props: {
          planStore,
        },
      };
    case "CoachingPlan":
      return {
        Component: Coaching,
      };
    case "SelfDevelopment":
      return {
        label: "Self Development",
        Component: SelfDevelopment,
      };
    case "TrainingNeeds":
      return {
        Component: TrainingNeeds,
      };
    case "ConfidentialSection":
      return {
        Component: Confidential,
        props: {
          planStore,
          setPlanStore,
        },
      };
    default:
      return {
        Component: () => {
          return (
            <div className="Flex">
              <Typography variant="h4">Invalid Section Type</Typography>
            </div>
          );
        },
      };
  }
}

export default function PMS() {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const Actions = getActions();
  const teamPlanData = location?.state?.Plan;

  const [modal, setModal] = useState(null);
  const [planStore, setPlanStore] = useState(null);
  const [isLoading, setIsLoading] = useState("");

  console.log(store.getState(), "REDUX_STORE_HERE");

  useEffect(() => {
    (async () => {
      setIsLoading("Loading Plan...");
      const location =
        localStorage.getItem("EPP_NAV_LOCATION") || "/myteamplan";
      try {
        let eppId =
          sessionStorage.getItem("EPP_NAV_DATA") ||
          teamPlanData?.TransactionID ||
          null;
        let eppDoc = teamPlanData;
        if (!eppId && !eppDoc) {
          localStorage.clear("EPP_NAV_LOCATION");
          history.push(location);
          return;
        }
        if (eppDoc) {
          sessionStorage.setItem("EPP_NAV_DATA", teamPlanData?.TransactionID);
        }

        let data = await loadPlan(eppId, null, eppDoc?.CurrentStatus || "");

        if (!data || data === null) {
          localStorage.clear("EPP_NAV_LOCATION");
          history.push(location);
          return;
        }

        console.log(data, "COMPLETE_LOADED_PLAN_DATA");

        setIsLoading("It is taking longer than expected, Please wait...");
        const revisedData = await reloadPlanBasedOnScores(eppId, data);

        console.log(revisedData, "RELOADED_PLAN_DATA");

        setPlanStore(revisedData || data);
      } catch (e) {
        console.log(e);
      }
      setIsLoading("");
    })();

    return () => {
      dispatch({
        type: Actions.ADD_SIDE_COMPONENT,
        payload: null,
      });

      sessionStorage.removeItem("EPP_NAV_DATA");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Plan = planStore?.EPP || {};
  const PlanDescription = planStore?.MPP?.PlanDescription || "";

  const Dimensions = [
    ...(Plan?.Dimensions || []).map((dimension) =>
      dimension.DimensionID
        ? {
            label: dimension.DimensionName || "Unnamed Dimension",
            Component: Dimension,
            props: {
              EmployeePerformancePlanID: Plan?.TransactionID,
              DimensionID: dimension.DimensionID,
              DimensionName: dimension.DimensionName || "Unnamed Dimension",
              DimensionPhase: "G",
              setPlanStore,
              planStore,
              dimensionData: planStore?.Dimensions || {},
            },
          }
        : undefined
    ),
  ].filter((dimension) => dimension !== undefined);

  const Sections = [
    ...(Plan?.Sections || []).map((section) => {
      return section.SectionType === "ConfidentialSection" &&
        getUserId() === Plan?.AppraiseeUserID
        ? undefined
        : {
            label: section.SectionName || "Unnamed Section",
            ...getSection(section.SectionType, planStore, setPlanStore),
          };
    }),
  ].filter((section) => section !== undefined);

  if (Dimensions.length === 0 && Sections.length === 0) {
    Dimensions.push({
      label: "Notice",
      Component: () => {
        return (
          <div className="Flex">
            <Typography variant="h6">
              All the sections and dimensions are disabled!
            </Typography>
          </div>
        );
      },
    });
  }

  console.log(planStore, "COMPLETE_PLAN_STORE");

  return (
    <>
      <EwModal
        open={modal !== null ? true : false}
        onClose={() => setModal(null)}
      >
        {modal}
      </EwModal>
      <div>
        <Box className="Flex" sx={{ alignItems: "normal", gap: "1em" }}>
          <Typography variant="h2" color={"primary"}>
            Performance Plan
          </Typography>
          <Typography variant="caption">{PlanDescription}</Typography>
          {isLoading !== "" ? (
            <>{isLoading}</>
          ) : (
            <Tabs componentList={[...Sections, ...Dimensions]} />
          )}
        </Box>
      </div>
    </>
  );
}
